import { select, put } from "redux-saga/effects";
import { LOG_EVENT_TYPES } from "../../../app/appConstants";
import { getIsAppVisibility } from "../../../app/appSelectors";
import { getLiteTradeConfig } from "../../../modules/LiteTrade/liteTradeSelectors";
import { NOTIFICATIONS_MESSAGE_TYPES } from "../../../modules/Notifications/notificationsConstants";
import { sendNotificationMessageAction } from "../../../modules/Notifications/notificationsReducer";
import { getWebsocketReadyStateNum } from "../websocketSelectors";

// бизнесс логика из LiteTradeWSConnector
const prevStateOnLiteTradeWSConnector = {
    readyState: null,
    isAppVisibility: null,
    liteTradeConfig: null,
};
export function* onLiteTradeWSConnectorSaga() {
    const liteTradeConfig = yield select(getLiteTradeConfig);
    const isAppVisibility = yield select(getIsAppVisibility);
    const readyState = yield select(getWebsocketReadyStateNum);
    // if (
    //     typeof liteTradeConfig?.wssUrl === 'string' &&
    //     (prevStateOnLiteTradeWSConnector.readyState !== readyState ||
    //     prevStateOnLiteTradeWSConnector.isAppVisibility !== isAppVisibility ||
    //     prevStateOnLiteTradeWSConnector.liteTradeConfig !== liteTradeConfig)
    // ) {
    //     yield put(
    //         sendNotificationMessageAction({
    //             type: NOTIFICATIONS_MESSAGE_TYPES.APP_LOG,
    //             params: {
    //                 event: LOG_EVENT_TYPES.WSS_CONNECTION,
    //                 payload: {
    //                     description: liteTradeConfig.wssUrl,
    //                     isAppVisibility,
    //                     readyState,
    //                 },
    //             },
    //         }),
    //     );
    // }
    prevStateOnLiteTradeWSConnector.readyState = readyState;
    prevStateOnLiteTradeWSConnector.isAppVisibility = isAppVisibility;
    prevStateOnLiteTradeWSConnector.liteTradeConfig = liteTradeConfig;
}
